import { BudgetTemplate } from '../budgetTemplates/budgetTemplatesApi';

interface TemplateSelectorProps {
  templates: BudgetTemplate[];
  selectedTemplateId?: number;
  onChange: (templateId: number | undefined) => void;
  loading?: boolean;
  disabled?: boolean;
}

export function TemplateSelector({
  templates,
  selectedTemplateId,
  onChange,
  loading = false,
  disabled = false,
}: TemplateSelectorProps) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onChange(value ? parseInt(value, 10) : undefined);
  };

  if (loading) {
    return (
      <div>
        <label
          htmlFor="template-select"
          className="block text-foreground mb-2"
          style={{
            fontSize: 'var(--text-caption)',
            fontWeight: 'var(--font-weight-semi-bold)',
          }}
        >
          Template <span className="text-danger">*</span>
        </label>
        <select
          id="template-select"
          disabled
          className="w-full px-3 py-2 border border-border rounded bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary disabled:opacity-50 disabled:cursor-not-allowed"
          style={{
            borderRadius: 'var(--radius-button)',
            fontSize: 'var(--text-base)',
          }}
        >
          <option>A carregar templates...</option>
        </select>
      </div>
    );
  }

  if (templates.length === 0) {
    return (
      <div>
        <label
          htmlFor="template-select"
          className="block text-foreground mb-2"
          style={{
            fontSize: 'var(--text-caption)',
            fontWeight: 'var(--font-weight-semi-bold)',
          }}
        >
          Template <span className="text-danger">*</span>
        </label>
        <select
          id="template-select"
          disabled
          className="w-full px-3 py-2 border border-border rounded bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary disabled:opacity-50 disabled:cursor-not-allowed"
          style={{
            borderRadius: 'var(--radius-button)',
            fontSize: 'var(--text-base)',
          }}
        >
          <option>Nenhum template disponível</option>
        </select>
        <small className="block mt-2 text-secondary-text" style={{ fontSize: 'var(--text-caption)' }}>
          Ainda não existem templates criados. Crie o seu primeiro template 
          gravando um orçamento existente.
        </small>
      </div>
    );
  }

  const selectedTemplate = templates.find(t => t.id === selectedTemplateId);

  return (
    <div>
      <label
        htmlFor="template-select"
        className="block text-foreground mb-2"
        style={{
          fontSize: 'var(--text-caption)',
          fontWeight: 'var(--font-weight-semi-bold)',
        }}
      >
        Template <span className="text-danger">*</span>
      </label>
      <select
        id="template-select"
        value={selectedTemplateId || ''}
        onChange={handleChange}
        disabled={disabled}
        className="w-full px-3 py-2 border border-border rounded bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary disabled:opacity-50 disabled:cursor-not-allowed"
        style={{
          borderRadius: 'var(--radius-button)',
          fontSize: 'var(--text-base)',
        }}
      >
        <option value="">Selecione um template...</option>
        {templates.map((template) => (
          <option key={template.id} value={template.id}>
            {template.name} ({template.chapterCount} capítulos, {template.itemCount} items)
            {template.createdByUserName && ` - criado por ${template.createdByUserName}`}
          </option>
        ))}
      </select>
      {selectedTemplate && selectedTemplate.description && (
        <small className="block mt-2 text-secondary-text" style={{ fontSize: 'var(--text-caption)' }}>
          {selectedTemplate.description}
        </small>
      )}
    </div>
  );
}
